import axios from 'axios';

import { AUTH, MEMBRESIA } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const obtenerMembresia = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/membresia/detalles`, config);

        await dispatch({
            type: MEMBRESIA.DETALLES,
            payload: res.data.actual
        });

        await dispatch({
            type: MEMBRESIA.BUSCAR,
            payload: res.data.membresias
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarMembresia = () => dispatch => {
    dispatch({
        type: MEMBRESIA.DETALLES,
        payload: null
    });

    dispatch({
        type: MEMBRESIA.BUSCAR,
        payload: []
    });

    dispatch({
        type: MEMBRESIA.SETUP_INTENT,
        payload: null
    });

    dispatch({
        type: MEMBRESIA.PAGOS,
        payload: []
    });
}

export const obtenerSetupIntent = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/membresia/setup-intent`, config);

        await dispatch({
            type: MEMBRESIA.SETUP_INTENT,
            payload: res.data.client_secret
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const contratarMembresia = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/membresia/contratar`, body, config);

        await dispatch({
            type: MEMBRESIA.DETALLES,
            payload: res.data.actual
        });

        await dispatch({
            type: MEMBRESIA.BUSCAR,
            payload: res.data.membresias
        });

        await dispatch({
            type: AUTH.MEMBRESIA_USUARIO,
            payload: res.data.actual
        });

        await dispatch(obtenerPagosMembresia());
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const cancelarMembresia = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/membresia/cancelar`, body, config);

        await dispatch({
            type: MEMBRESIA.DETALLES,
            payload: res.data.actual
        });

        await dispatch({
            type: MEMBRESIA.BUSCAR,
            payload: res.data.membresias
        });

        await dispatch({
            type: AUTH.MEMBRESIA_USUARIO,
            payload: res.data.actual
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const desactivarRenovacion = (datos) => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/membresia/desactivar_renovacion`, body, config);

        await dispatch({
            type: MEMBRESIA.DETALLES,
            payload: res.data.actual
        });

        await dispatch({
            type: MEMBRESIA.BUSCAR,
            payload: res.data.membresias
        });

        await dispatch({
            type: AUTH.MEMBRESIA_USUARIO,
            payload: res.data.actual
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerPagosMembresia = () => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/membresia/pagos`, config);

        await dispatch({
            type: MEMBRESIA.PAGOS,
            payload: res.data.pagos
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}